export enum AffiliateChartColorsEnum {
  currency_blue = '#00A0FF',
  currency_green = '#11AD84',
  currency_yellow = '#ffc107',
  currency_red = '#ED1C24',
}
